var {AmpersandModel} = require('catalog/libs');

var HPELog = require('core/log');

module.exports = AmpersandModel.extend({

	/**
	 * state properties
	 */
	props: {
		originPath: 'string',
		animating: ['boolean', true, false],
		headerEnabled: ['boolean', true, false],
		scrollLeft: ['number', true, 0],
		i18nAddAnother: 'string'
	},

	/**
	 * fetch from service URL
	 */
	fetch: function(url) {

		var options = {};

		var path = url.replace(/.html/i, '.json');

		//response callbacks + configuration
		options.url = path;
		options.success = this.onFetchSuccess.bind(this);
		options.error = this.onFetchError.bind(this);

		return AmpersandModel.prototype.fetch.call(this, options);
	},

	/**
	 * handle success response from fetch()
	 * @param {object} model reference
	 * @param {object} response server response
	 */
	onFetchSuccess: function(model, response) {
		//do not proceeed unless a successful response
		if (window.digitalData && response && response.status === 'success') {

			window.digitalData.product = [];

			response.productDataCompare.forEach(function(data) {
				var product = {
					category: {
						catalogType: data.catalogTypeAnalyticsValue,
						catalogCategory: data.catalogCategoryAnalyticsValue
					},
					productInfo: {
						productID: data.oid,
						productName: data.productNameAnalyticsValue
					}
				};
				window.digitalData.product.push(product);
			});
		} else {
			this.onFetchError(model, response);
		}
	},

	/**
	 * handle error response from fetch()
	 * @param {object} [model] referencer
	 * @param {object} [response] server response
	 */
	onFetchError: function(model, response) {
		HPELog.error('[Products]: product list model fetch error', response);
	}
});
